/* tslint:disable */
/* eslint-disable */
export enum LiveBiddingCreditMode {
  CheckRemainingCredit = 'check_remaining_credit',
  ConsiderPendingPrebids = 'consider_pending_prebids',
  ConsiderHighestPendingPrebids = 'consider_highest_pending_prebids'
}
